import React from 'react';
import { Plus, DollarSign, Pencil, Save, X, Package } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';

const DocumentItems = ({
  items, editItems, editedItems, canEdit, loadingPrices,
  onEditItems, onSaveItems, onCancelEdit, onLoadPrices, onOpenAddItem,
  onDeleteItem, onUpdateEditedItem
}) => {
  return (
    <div className="bg-white border border-[#E5E5EA] rounded-xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-semibold text-[#111111]">Itens do Documento</h3>
        {canEdit && (
          <div className="flex gap-2">
            {editItems ? (
              <>
                <Button size="sm" variant="outline" onClick={onCancelEdit}>Cancelar</Button>
                <Button size="sm" className="bg-[#AF2628] hover:bg-[#961B22]" onClick={onSaveItems} data-testid="save-items-button">
                  <Save className="w-3.5 h-3.5 mr-1" />Salvar Itens
                </Button>
              </>
            ) : (
              <>
                <Button size="sm" variant="outline" onClick={onOpenAddItem} data-testid="add-item-button">
                  <Plus className="w-3.5 h-3.5 mr-1" />Adicionar Item
                </Button>
                <Button size="sm" variant="outline" onClick={onLoadPrices} disabled={loadingPrices} data-testid="load-prices-button">
                  <DollarSign className="w-3.5 h-3.5 mr-1" />{loadingPrices ? 'Carregando...' : 'Carregar Precos'}
                </Button>
                {items.length > 0 && (
                  <Button size="sm" variant="outline" onClick={onEditItems} data-testid="edit-items-button">
                    <Pencil className="w-3.5 h-3.5 mr-1" />Editar Itens
                  </Button>
                )}
              </>
            )}
          </div>
        )}
      </div>

      {items.length === 0 && !editItems ? (
        <div className="text-center py-8 text-[#AEAEB2]">
          <Package className="w-10 h-10 mx-auto mb-2 opacity-50" />
          <p className="text-sm">Nenhum item no documento</p>
          {canEdit && <p className="text-xs mt-1">Clique em "Adicionar Item" para incluir produtos</p>}
        </div>
      ) : (
        <div className="border border-[#E5E5EA] rounded-lg overflow-hidden">
          <table className="w-full">
            <thead className="bg-[#F7F7F8]">
              <tr>
                <th className="text-left p-3 text-xs font-medium text-[#6E6E73]">ITEM</th>
                {editItems && <th className="text-left p-3 text-xs font-medium text-[#6E6E73]">DESCRICAO</th>}
                <th className="text-center p-3 text-xs font-medium text-[#6E6E73]">UNID.</th>
                <th className="text-center p-3 text-xs font-medium text-[#6E6E73]">QTD</th>
                <th className="text-right p-3 text-xs font-medium text-[#6E6E73]">VALOR UNIT.</th>
                <th className="text-right p-3 text-xs font-medium text-[#6E6E73]">TOTAL</th>
                {canEdit && !editItems && <th className="w-10 p-3"></th>}
              </tr>
            </thead>
            <tbody>
              {editItems ? editedItems.map((item) => (
                <tr key={item.item_id} className="border-t border-[#E5E5EA]">
                  <td className="p-3 text-sm"><div className="font-medium">{item.product_name}</div></td>
                  <td className="p-2">
                    <Input value={item.descricao_resumida} onChange={(e) => onUpdateEditedItem(item.item_id, 'descricao_resumida', e.target.value)} className="text-sm h-8" data-testid={`item-desc-${item.item_id}`} />
                  </td>
                  <td className="p-2 w-24">
                    <Input value={item.unidade} onChange={(e) => onUpdateEditedItem(item.item_id, 'unidade', e.target.value)} className="text-sm text-center h-8" data-testid={`item-unit-${item.item_id}`} />
                  </td>
                  <td className="p-2 w-24">
                    <Input type="number" value={item.quantity} onChange={(e) => onUpdateEditedItem(item.item_id, 'quantity', e.target.value)} className="text-sm text-center h-8" data-testid={`item-qty-${item.item_id}`} />
                  </td>
                  <td className="p-2 w-32">
                    <Input type="number" step="0.01" value={item.unit_price_applied} onChange={(e) => onUpdateEditedItem(item.item_id, 'unit_price_applied', e.target.value)} className="text-sm text-right h-8" data-testid={`item-price-${item.item_id}`} />
                  </td>
                  <td className="p-3 text-sm text-right font-medium">
                    R$ {((parseFloat(item.quantity) || 0) * (parseFloat(item.unit_price_applied) || 0)).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </td>
                </tr>
              )) : items.map((item) => (
                <tr key={item.item_id} className="border-t border-[#E5E5EA] group">
                  <td className="p-3 text-sm">
                    <div className="font-medium">{item.product_name}</div>
                    {(item.descricao_resumida || item.product_description) && <div className="text-xs text-[#6E6E73]">{item.descricao_resumida || item.product_description}</div>}
                  </td>
                  <td className="p-3 text-sm text-center">{item.unidade}</td>
                  <td className="p-3 text-sm text-center">{item.quantity}</td>
                  <td className="p-3 text-sm text-right">R$ {(item.unit_price_applied || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                  <td className="p-3 text-sm text-right font-medium">R$ {(item.total_price || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</td>
                  {canEdit && (
                    <td className="p-2 text-center">
                      <button onClick={() => onDeleteItem(item.item_id, item.product_name)} className="text-[#AEAEB2] hover:text-red-600 opacity-0 group-hover:opacity-100 transition-opacity" title="Remover item" data-testid={`delete-item-${item.item_id}`}>
                        <X className="w-4 h-4" />
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
            <tfoot className="bg-[#F7F7F8]">
              <tr>
                <td colSpan={editItems ? "5" : (canEdit ? "5" : "4")} className="p-3 text-right font-bold text-sm">VALOR TOTAL</td>
                <td className="p-3 text-right font-bold text-[#AF2628]" colSpan={canEdit && !editItems ? 2 : 1}>
                  R$ {(editItems
                    ? editedItems.reduce((sum, it) => sum + (parseFloat(it.quantity) || 0) * (parseFloat(it.unit_price_applied) || 0), 0)
                    : items.reduce((sum, item) => sum + (item.total_price || 0), 0)
                  ).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}
    </div>
  );
};

export default DocumentItems;
